import {
    FlowPreviewModalViewMode,
    INSTALL_ISSUE_VIEW_MODE,
    NEVER_INSTALLED_VIEW_MODE,
    VERIFIED_VIEW_MODE,
} from '@/types/flow-preview-mode.type';
import { differenceInHours, parseISO } from 'date-fns';

export function getFlowPreviewMode(
    installationVerifiedAt: string | null,
    isCodeInstalled: boolean,
): FlowPreviewModalViewMode {
    let lastInstallationVerifiedAtHoursAgo = null;

    if (installationVerifiedAt) {
        try {
            const verifiedDate = parseISO(installationVerifiedAt);

            lastInstallationVerifiedAtHoursAgo = differenceInHours(
                new Date(),
                verifiedDate,
            );
        } catch (ex) {}
    }

    if (
        lastInstallationVerifiedAtHoursAgo &&
        lastInstallationVerifiedAtHoursAgo > 72
    ) {
        return INSTALL_ISSUE_VIEW_MODE;
    } else if (isCodeInstalled) {
        return VERIFIED_VIEW_MODE;
    }

    return NEVER_INSTALLED_VIEW_MODE;
}
